import { IHSBLocationManager } from "core/interfaces/data/IHSBLocationManager";
import { selectFormData } from "core/redux/features/dataForm/dataFormSlice";
import { IDataFormSlice } from "core/redux/features/dataForm/dataFormSliceInterfaces";
import { selectSession } from "core/redux/features/session/sessionSlice";
import { ISessionStateData } from "core/redux/features/session/sessionSliceInterfaces";
import { useAppDispatch, useAppSelector } from "core/redux/store/hooks";
import { AppDispatch } from "core/redux/store/store";
import { i18n } from "i18next";
import React from "react";
// import AriaModal from "react-aria-modal";
import { useErrorHandler } from "react-error-boundary";
import { TFunction, useTranslation } from "react-i18next";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";

export const Enhanced = (WrappedComponent: any, options: IEnhancedProps) => {
	const Wrapper = React.forwardRef((props: any, ref: any) => {
		const s = useAppSelector(selectSession);
		const form: IDataFormSlice = useAppSelector(selectFormData);
		const d = useAppDispatch();

		let n = useNavigate();
		let l = useLocation() as IHSBLocationManager;

		var namespace = options?.componentNamespace ?? "Generale";

		const { i18n, t } = useTranslation(`HSB.${namespace}`);

		const handleError = useErrorHandler();

		var customProp: IReactComponentBase = {
			reactNameSpace: namespace,
			i18n: i18n,
			t: t,
			sessionInfo: s,
			dispatch: d,
			navigate: n,
			location: l,
			dataForm: form,
			handleError: handleError,
			...props,
		};

		return <WrappedComponent ref={ref} {...customProp} />;
	});
	return Wrapper;
};

export interface IReactComponentBase {
	reactNameSpace: string;
	t: TFunction<string, undefined>;
	i18n: i18n;
	sessionInfo: ISessionStateData;
	dispatch: AppDispatch;
	navigate: NavigateFunction;
	location: IHSBLocationManager;
	dataForm: IDataFormSlice;
	handleError:(error: unknown) => void;
}


export interface IEnhancedProps {
	componentNamespace?: string;
}